import { Link } from 'react-router-dom';

export default function LegalNav() {
  return (
    <header className="bg-black/90 border-b border-gray-800 py-5">
      <div className="max-w-7xl mx-auto px-5 flex justify-between items-center flex-wrap gap-4">
        <Link to="/vod" className="flex items-center gap-1">
          <img src="/ltv-vod-logo.png" alt="LTV VOD" className="h-8" onError={(e) => { e.target.style.display = 'none'; e.target.nextElementSibling.style.display = 'inline'; }} />
          <span style={{ display: 'none' }} className="text-2xl font-bold text-white">LTV <span className="text-purple-500">VOD</span></span>
        </Link>
        <nav className="flex gap-6 flex-wrap">
          <Link to="/vod" className="text-gray-400 hover:text-white transition-colors text-sm">Home</Link>
          <Link to="/vod/browse" className="text-gray-400 hover:text-white transition-colors text-sm">Browse</Link>
          <Link to="/vod/membership" className="text-gray-400 hover:text-white transition-colors text-sm">Membership</Link>
          <Link to="/live" className="text-gray-400 hover:text-white transition-colors text-sm">Live Events</Link>
          <Link to="/creator" className="text-gray-400 hover:text-white transition-colors text-sm">Creators</Link>
          <Link to="/vod/blog" className="text-gray-400 hover:text-white transition-colors text-sm">Blog</Link>
          <Link to="/about" className="text-gray-400 hover:text-white transition-colors text-sm">About</Link>
          <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm">Contact</Link>
        </nav>
        <Link to="/vod" className="bg-blue-600 hover:bg-blue-500 text-white px-5 py-2 rounded-full text-sm font-medium transition-colors">
          Sign In
        </Link>
      </div>
    </header>
  );
}
